module.exports = __webpack_public_path__ + "static/media/gatilho_ativo.c7cbb26d.svg";